import component from './FormSettings.vue'
export default component
